import { useState } from "react";
import VaultFilters from "./VaultFilters";
import VaultCards from "./VaultCards";
import "../../css/VaultAccess/vault_access_layout.css";

export default function VaultAccess() {
    const [products, setProducts] = useState([]);
    const [totalProducts, setTotalProducts] = useState(0);

    return (
        <div className="vault-page">
            <VaultFilters loadedCount={products.length} totalCount={totalProducts} />
            <VaultCards products={products} setProducts={setProducts} setTotalProducts={setTotalProducts} />
        </div>
    );
}